import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Search, PlusCircle, MessageSquare, User } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const TABS = [
  { key: 'home', label: 'Home', icon: Home, path: '/' },
  { key: 'search', label: 'Search', icon: Search, path: '/search' },
  { key: 'sell', label: 'Sell', icon: PlusCircle, path: '/post-ad', accent: true },
  { key: 'messages', label: 'Messages', icon: MessageSquare, path: '/my-gopiko?tab=messages' },
  { key: 'profile', label: 'Profile', icon: User, path: '/my-gopiko' },
];

const HIDDEN_PATHS = ['/reels/watch', '/reels/create', '/login', '/signup'];

const MobileBottomTabBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const pathname = location.pathname;
  const search = location.search;

  // Hide on certain full-screen pages
  if (HIDDEN_PATHS.some(p => pathname.startsWith(p))) return null;

  const isActive = (tab) => {
    if (tab.key === 'home') return pathname === '/';
    if (tab.key === 'search') return pathname === '/search';
    if (tab.key === 'sell') return pathname === '/post-ad';
    if (tab.key === 'messages') return pathname === '/my-gopiko' && search.includes('tab=messages');
    if (tab.key === 'profile') return pathname === '/my-gopiko' && !search.includes('tab=messages');
    return false;
  };

  const handleTap = (tab) => {
    if ((tab.key === 'messages' || tab.key === 'profile') && !user) {
      navigate('/login');
      return;
    }
    navigate(tab.path);
  };

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 md:hidden safe-area-bottom"
      data-testid="mobile-bottom-tab-bar"
    >
      <div className="flex items-center justify-around h-14 max-w-lg mx-auto px-1">
        {TABS.map((tab) => {
          const active = isActive(tab);
          const Icon = tab.icon;

          if (tab.accent) {
            return (
              <button
                key={tab.key}
                onClick={() => handleTap(tab)}
                className="flex flex-col items-center justify-center -mt-1 group"
                data-testid={`tab-${tab.key}`}
              >
                <div className="w-9 h-9 rounded-full bg-red-600 flex items-center justify-center shadow-md shadow-red-200 group-active:scale-90 transition-transform">
                  <Icon className="w-5 h-5 text-white" strokeWidth={2.5} />
                </div>
                <span className="text-[10px] font-semibold text-red-600 mt-0.5">{tab.label}</span>
              </button>
            );
          }

          return (
            <button
              key={tab.key}
              onClick={() => handleTap(tab)}
              className="flex flex-col items-center justify-center flex-1 py-1 group active:scale-90 transition-transform"
              data-testid={`tab-${tab.key}`}
            >
              <Icon
                className={`w-5 h-5 transition-colors ${active ? 'text-red-600' : 'text-gray-400 group-hover:text-gray-600'}`}
                strokeWidth={active ? 2.5 : 1.8}
              />
              <span className={`text-[10px] mt-0.5 transition-colors ${active ? 'font-bold text-red-600' : 'font-medium text-gray-400'}`}>
                {tab.label}
              </span>
              {active && <div className="w-1 h-1 rounded-full bg-red-600 mt-0.5" />}
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomTabBar;
